module.exports = __webpack_public_path__ + "static/img/EasyWallet.2ec389e1.png";